import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, ApiError } from "../lib/api.js";
import { common } from "../copy/common.js";
import { errors } from "../copy/errors.js";
import { lists as listCopy } from "../copy/lists.js";
import { ListGrid, type ListSummary } from "../components/ListGrid.js";
import { Banner, ButtonLink } from "../components/ui.js";

/**
 * Lists the child put away (issue #99), own and class lists together, the
 * last archived first. «Zurückholen» sits on the list itself, next to where it
 * was archived. The words are not paused: they keep coming in «heute dran».
 */
export function ArchiveScreen() {
  const [lists, setLists] = useState<ListSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void api<{ lists: ListSummary[] }>("/api/lists?scope=archived")
      .then((data) => setLists(data.lists))
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : errors.failed));
  }, []);

  return (
    <div className="space-y-6 lg:space-y-8">
      <Link
        to="/"
        className="inline-flex items-center gap-1 font-semibold text-fox-ink underline-offset-4 hover:underline"
      >
        {common.backToStart}
      </Link>
      <div>
        <h1 className="text-3xl sm:text-4xl">{listCopy.archive.title}</h1>
        <p className="mt-2 text-ink-soft">{listCopy.archive.hint}</p>
      </div>
      {/* After the exam the lists land here, and here is where «alles aus Unit
          1–4» starts (issue #101). */}
      {lists && lists.length > 0 ? (
        <div className="sm:max-w-sm">
          <ButtonLink to="/review" variant="ghost">
            {listCopy.archive.review}
          </ButtonLink>
        </div>
      ) : null}
      {error ? <Banner>{error}</Banner> : null}
      {error ? null : lists && lists.length === 0 ? (
        <p className="text-ink-soft">{listCopy.archive.empty}</p>
      ) : (
        <ListGrid kind="archived" lists={lists} />
      )}
    </div>
  );
}
